// Exports the "legacyoutput" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/legacyoutput')
//   ES2015:
//     import 'tinymce/plugins/legacyoutput'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/legacyoutput/index.js
// module id = YR2B
// module chunks = 1